import ContactInfo from "@/components/landing/contact/ContactInfo";
import ContactForm from "@/components/landing/contact/ContactForm";
import ContactMap from "@/components/landing/contact/ContactMap";

const ContactSection = () => (
  <section className="contact-band" id="contact" data-testid="contact-section">
    <div className="container contact-container" data-testid="contact-container">
      <ContactInfo />
      <ContactForm />
      <ContactMap />
    </div>
  </section>
);

export default ContactSection;
